import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { Typography } from '@mui/material';
import moment from 'moment';
import KenDialog from '../../Components/KenDialog/index';
import { useApplicationContext } from '../../Context/applicationContext';
import { AuthContext } from '../../Context/authContext';
import { getVisibleSteps } from '../../Utils/Helpers/applicationHelper';
import {
  createUpdateApplication,
  getAllPrograms,
  getApplicationByApplicationId,
} from '../../Utils/apiServices';
import Instructions from '../KenApplicationForm/Components/InstructionsPage';
import KenStepperFooter from '../KenApplicationForm/Components/KenStepperFooter';
import KenLoader from '../KenLoader/index';

export default function InstructionsStep() {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const [loading, setLoading] = useState();
  const [formData, setFormData] = useState();
  const [dialog, setDialog] = useState();

  console.log(location);

  // Application context to update the applicationId, data and active step
  const {
    applicationState: { formId, form, applicationId, applicantId },
    applicationDispatch,
  } = useApplicationContext();

  console.log(useApplicationContext());

  const {
    state: { user },
    dispatch,
  } = useContext(AuthContext);

  useEffect(() => {
    getAllPrograms(user?.id).then((res) => {
      const { data } = res;
      if (data?.length > 0) {
        data.forEach((el) => {
          if (moment().isBetween(el?.startDate, el?.endDate)) {
            setFormData(el);
            setSearchParams({ formId: el.recordId });
          }
        });
      } else {
        setDialog(true);
      }
    });
  }, []);

  // Create the application on next and update the url with applicationId params
  const handleNext = () => {
    setLoading(true);

    // Create application
    createUpdateApplication({
      application: {
        Startup_Application_Form__c: formId,
        // programName: form?.programName,
        hed__Applicant__c: applicantId,
        // applicationForm: formId,
        Current_Step__c: 0,
      },
    })
      .then((res) => {
        // update url - must for proper functions on reload and applicationContect
        if (res.success === true && res?.applicationId) {
          getApplicationByApplicationId(res?.applicationId).then((resp) => {
            const steps = getVisibleSteps(formData?.metadata);
            const payload = {
              activeStep: 0,
              applicationId: res.applicationId,
              applicationData: resp?.data,
              steps,
              totalSteps: steps.length,
            };
            applicationDispatch({ type: 'update', payload });
            setSearchParams({
              applicationId: res.applicationId,
              formId: formData.recordId,
            });
            setLoading(false);
          });
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  return (
    <div>
      <div style={{ marginBottom: 70 }}>
        {loading && <KenLoader />}
        <Instructions />
      </div>
      {/* <Footer isSave={false} isPrev={false} onNext={handleNext} /> */}
      <KenStepperFooter isSave={false} isPrev={false} onNext={handleNext} />
      <KenDialog
        open={dialog}
        dialogActions={true}
        positiveButtonProps={{
          style: {
            color: '#fff',
            backgroundColor: '#092682',
            borderRadius: '4px',
            '&:hover': {
              cursor: 'pointer',
              background: '#DFE8FF',
              color: '#505F79',
            },
            padding: '8px 22px',
            fontSize: 14,
            marginBottom: 16,
          },
        }}
        positiveButtonText={'Logout'}
        positiveButtonLabelProps={{
          style: {
            color: '#fff',
          },
        }}
        hideNegativeButton={true}
        positiveButtonClick={() => {
          // sameApplicationData && goToSameApplication();
          dispatch({
            type: 'LOGOUT',
            payload: {
              user: {},
              token: null,
            },
          });
        }}
      >
        <Typography fontSize={16} fontWeight={500}>
          Applications are now closed.
        </Typography>
      </KenDialog>
    </div>
  );
}
